import { CanActivate } from '@angular/router';
import { Auth, authState } from '@angular/fire/auth';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { AUTH_SERVICE_CONFIG } from './_models/auth-service-config';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  private auth = inject(Auth);
  private config = inject(AUTH_SERVICE_CONFIG);

  canActivate() {
    return authState(this.auth).pipe(
      map(user => {
        if (user) return true;

        // redirect user to account login
        const returnUrl = window.location.href;
        console.log(returnUrl);
        const loginUrl = new URL(this.config.urls.accountOrigin + '/login');
        loginUrl.searchParams.set('returnUrl', returnUrl);

        // CSRF protection
        const state = crypto.getRandomValues(new Uint32Array(4)).join('-');
        sessionStorage.setItem('sso_state', state);
        loginUrl.searchParams.set('state', state);

        window.location.assign(loginUrl.toString());
        return false;
      })
    );
  }

}
